define("settings/components/migration-banner", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.showBanner}}
    <div class="tAC--banner" data-test-id="banner">
      <div class="u--row">
        <div class="u--col__9">
          <h2 class="u--text--lg u--m__tb__sm">
            {{t "account.migration_banner.title"}}
          </h2>
          <p class="u--text--md">
            {{html-safe (t "account.migration_banner.description")}}
          </p>
          <ul class="u--listUnstyle u--row u--row--noCollapse u--p__t__xs">
            <li class="u--col__4 u--p__b__xs">
              {{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_1"}}
            </li>
            <li class="u--col__8 u--p__b__xs">
              {{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "shared_phrases.search_profile"}}
            </li>
            <li class="u--col__4 u--p__b__xs">
              {{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_3"}}
            </li>
            <li class="u--col__8 u--p__b__xs">
              {{svg-jar "verified" class="o--icon u--m__r__xs"}}{{t "account.migration_banner.feature_4"}}
            </li>
          </ul>
          <div class="u--block u--m__t">
            <Shared::Button::Upgrade
              @feature="migrate"
              @location="subscription overview"
              @text={{t "account.migration_banner.button_plan"}}
              @track={{fn this.trackMigrationBanner "switch_new_plan"}}
              class="u--m__r qa--settings__button--upgrade"
            />
            <Shared::Link
              @href="https://help.later.com/hc/articles/1500004211501"
              @text={{t "account.migration_banner.button_compare"}}
              {{button variant="outline"}}
              {{on "click" (fn this.trackMigrationBanner "compare_plans")}}
            />
          </div>
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "L1hqvMHI",
    "block": "[[[41,[30,0,[\"showBanner\"]],[[[1,\"  \"],[10,0],[14,0,\"tAC--banner\"],[14,\"data-test-id\",\"banner\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n        \"],[10,\"h2\"],[14,0,\"u--text--lg u--m__tb__sm\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.migration_banner.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[[28,[37,1],[\"account.migration_banner.description\"],null]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"u--listUnstyle u--row u--row--noCollapse u--p__t__xs\"],[12],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__4 u--p__b__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_1\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__8 u--p__b__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"shared_phrases.search_profile\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__4 u--p__b__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_3\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,\"li\"],[14,0,\"u--col__8 u--p__b__xs\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,[28,[35,1],[\"account.migration_banner.feature_4\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--block u--m__t\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@feature\",\"@location\",\"@text\",\"@track\"],[\"migrate\",\"subscription overview\",[28,[37,1],[\"account.migration_banner.button_plan\"],null],[28,[37,5],[[30,0,[\"trackMigrationBanner\"]],\"switch_new_plan\"],null]]],null],[1,\"\\n          \"],[8,[39,6],[[4,[38,7],null,[[\"variant\"],[\"outline\"]]],[4,[38,8],[\"click\",[28,[37,5],[[30,0,[\"trackMigrationBanner\"]],\"compare_plans\"],null]],null]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/articles/1500004211501\",[28,[37,1],[\"account.migration_banner.button_compare\"],null]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"t\",\"html-safe\",\"svg-jar\",\"shared/button/upgrade\",\"fn\",\"shared/link\",\"button\",\"on\"]]",
    "moduleName": "settings/components/migration-banner.hbs",
    "isStrictMode": false
  });
  let MigrationBannerComponent = _exports.default = (_class = class MigrationBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }
    get showBanner() {
      return this.auth.currentAccount.isOnLegacyPlan && this.auth.currentUserModel.isAccountOwner && !this.auth.currentAccount.pricingV1Free;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    trackMigrationBanner(buttonText) {
      this.segment.track('clicked-legacy-migration-banner', {
        button_text: buttonText,
        plan_interval: this.subscriptionPlan.interval,
        plan_scheduled_end: this.subscription.activeUntil,
        plan_start: this.subscription.createdDate,
        user_id: this.auth.currentUserModel.id
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "trackMigrationBanner", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackMigrationBanner"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MigrationBannerComponent);
});